module.exports = __webpack_public_path__ + "static/media/Cheval-Breggins_1612374255025.88e6d995.jpg";